import { fetchHotelDataInfo, saveGuestDetailsToDatabase, saveRateHawkBookingToDb } from "../../../frontend/src/api-client";

export const processBooking = async (
  user: any,
  leadPassengerEmail: string,
  amount: number,
  bookingFormResponse: any,
  tripStartDate: string,
  tripEndDate: string,
  bookedDate: string,
  book_hash: string,
  holdOrPaid: string,
  actualAmount: string,
  status: string,
  orderNumber: string,
  primaryGuestName: string,
  passengers: any[],
) => {
  try {
    // Fetch hotel details
    const fetchHotelData = async (params: { id: string; language: string }) => {
      try {
        const hotelDataInfo = await fetchHotelDataInfo(params);
        console.log("Hotel Data Info:", hotelDataInfo);
        return hotelDataInfo;
      } catch (error) {
        console.error("Failed to fetch hotel data info", error);
      }
    };

    const hotelData = await fetchHotelData({ id: 'test_hotel', language: "en" });

    if (!hotelData) {
      throw new Error("Hotel data is missing or invalid.");
    }

    const userId = user?.userId ?? ""; 

    await saveRateHawkBookingToDb(
      userId,
      bookingFormResponse.data.partner_order_id,
      book_hash,
      tripStartDate,
      tripEndDate,
      bookedDate,
      amount.toString(),
      new Date().toISOString(),
      new Date().toISOString(),
      leadPassengerEmail,
      hotelData.data.id,
      hotelData.data.name,
      hotelData.data.postal_code ?? "",
      hotelData.data.address,
      holdOrPaid,
      actualAmount,
      status,
      orderNumber,
      primaryGuestName,
    );

    await saveGuestDetailsToDatabase(user.userId ?? '', passengers, bookingFormResponse.data.partner_order_id);

    return { hotelData };
  } catch (error) {
    console.error("Failed to process booking:", error);
    throw error;
  }
};
